import { Component, inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [NzModalModule, NzButtonModule],
})
export class LoginComponent {
  private keycloak = inject(Keycloak);

  public login() {
    this.keycloak.login({
      redirectUri: window.location.origin,
    });
  }
}
